module.exports = "/shifts/components/timeBlocksSidebarComponent-ab2b47.html";